import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class ChequeStopService {
    private baseApiUrl: string;

    constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
        this.baseApiUrl = configurationService.BaseApiUrl;
    }

    getFiltered(filter: string, pageIndex: number, pageSize: number,
        sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

        const params = {
            filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
        };

        return this.httpClient.post(this.baseApiUrl + 'chequestoppayment/filter', params).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getAll(forMaintenance: boolean = false): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `chequestoppayment?isMaintenance=${forMaintenance}`).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }


    computeInstallmentAndFees(computeData: any): Observable<any> {
      return this.httpClient.post(this.baseApiUrl + `chequestoppayment/compute`, computeData).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }


    getById(id: number, forMaintenance: boolean = false): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `chequestoppayment/${id}?isMaintenance=${forMaintenance}`).pipe(
            map((res: Response) => this.addChequebookDisplayData(res)),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    create(chequebook: any): Observable<any> {
        return this.httpClient.post(this.baseApiUrl + `chequestoppayment`, chequebook).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    update(chequebook: any): Observable<any> {
        return this.httpClient.put(this.baseApiUrl + `chequestoppayment`, chequebook).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    authorise(id: number): Observable<any> {
        return this.httpClient.post(this.baseApiUrl + `chequestoppayment/authorise`, id).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    delete(id: number): Observable<any> {
        return this.httpClient.delete(this.baseApiUrl + `chequestoppayment/${id}`).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    addChequebookDisplayData(chequestoppayment: any): any {
      chequestoppayment.displayData = `${chequestoppayment.name} - ${chequestoppayment.code}`;
        return chequestoppayment;
    }

    validateChequeNo(accountno: any, chequeno: any): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `chequestoppayment/validatechequeno/${accountno}?chequeno=${chequeno}`).pipe(
            map((res: Response) => this.addChequebookDisplayData(res)),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getByRevoke(accountNo: number,processStatus:number): Observable<any> {
      return this.httpClient.get(this.baseApiUrl + `chequestoppayment/accountNo/${accountNo}?processStatus=${processStatus= 2 || 3 }`).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

}